import PropTypes from "prop-types"
import React, { useMemo, useState } from "react"
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, Modal, ModalBody, Row, ModalHeader, ModalFooter, Collapse } from "reactstrap";
import { getRuleLogDetails } from "store/admin/dev-dashboard/actions";
import RulesLogTable from "./RulesLogTable";

const RulesLogModal = ({ show: { active, row }, onClickCloseModal }) => {
  const dispatch = useDispatch();

  const {
    rule_log_details,
    rule_log_details_loading,
  } = useSelector((state) => ({
    rule_log_details: state.DevDashboard.rule_log_details,
    rule_log_details_loading: state.DevDashboard.rule_log_details_loading,
  }))

  useEffect(() => {
    if (row?.id) {
      dispatch(getRuleLogDetails({ 
        id: row?.id
      }))
    }
  }, [row])

  const prepareDataForTable = useMemo(() => {
    if (row?.id) {
      return {
        id: row.id,
        logs: JSON.parse(row.logs),
        error_logs: rule_log_details,
        jira_url: row.jira_url,
      };
    }
    return {};
  }, [row, rule_log_details]);

  const [isBeautify, setIsBeautify] = useState(true);



  return (
    <Modal size="xl" isOpen={active} toggle={onClickCloseModal} centered={true}>
      <ModalHeader>
        <span className="modal-title mt-0">
          Rule Log Details
        </span>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onClickCloseModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={(e) => {
          e.preventDefault()
          return false;
        }}>
          <Row>
            <Col md={12}>
              <div style={{ height: "390px" }}>
                <div className="accordion-item bg-white rounded border-0">
                  <Collapse isOpen={true} className="accordion-collapse">
                    <div className="accordion-body pt-3">
                      <RulesLogTable
                        row={prepareDataForTable}
                        isBeautify={isBeautify}
                        loading={rule_log_details_loading}
                      />
                    </div>
                  </Collapse>
                </div>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <div className="mt-4 float-end">
          <button type="button" className="btn btn-light ms-2" name="close" onClick={onClickCloseModal}>
            Close
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

RulesLogModal.propTypes = {
  onClickCloseModal: PropTypes.func,
  show: PropTypes.object,
}

export default RulesLogModal;
